import { Flex, Typography, CodeViewer, Alert, cn } from "djuno-design";
import { buttonPageUrl, ddpPageUrl } from "../urls";
import CustomLink from "../components/CustomLink";

const { Title, Text } = Typography;

const InstallationGuide = () => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Flex direction="col">
        <Flex direction="col">
          <Title level={4}>Djuno Design Installation & Usage Guide</Title>
          <Text size="sm" style={{ marginBottom: 20 }}>
            Djuno Design is a modern, customizable design system for React
            applications. It provides a wide variety of components that are easy
            to use and highly customizable, ensuring consistency and
            accessibility across your UI. Follow the steps below to install and
            start using Djuno Design in your project.
          </Text>

          {/* Installation Steps */}
          <Flex direction="col" className="w-full">
            <Title level={5}>1. Install</Title>
            <Text size="sm">
              You can install the package using npm or yarn:
            </Text>
            <Flex direction="col" className="gap-2 mt-2 w-full md:!w-1/3">
              <CodeViewer
                language="bash"
                copyable
                theme="dark"
                code={`npm i djuno-design`}
              />
              <Text size="sm">Or</Text>
              <CodeViewer
                language="bash"
                copyable
                theme="dark"
                code={`yarn add djuno-design`}
              />
            </Flex>
          </Flex>

          {/* Importing Styles */}
          <Flex direction="col" className="w-full mt-10">
            <Title level={5}>2. Import Styles</Title>
            <Text size="sm">
              Import the package's styles at the top of your component tree:
            </Text>
            <Flex direction="col" className="gap-2 mt-2 w-full md:!w-1/3">
              <CodeViewer
                language="javascript"
                copyable
                theme="dark"
                code={`import "djuno-design/dist/index.css";`}
              />
            </Flex>
          </Flex>

          {/* Importing Components */}
          <Flex direction="col" className="w-full mt-10 mb-5">
            <Title level={5}>3. Use Components</Title>
            <Text size="sm">
              You can now import and use Djuno Design components anywhere in
              your project. Here's a basic example with the{" "}
              <CustomLink to={buttonPageUrl}>
                <Text size="sm" strong uiType="transparent">
                  Button
                </Text>
              </CustomLink>{" "}
              component:
            </Text>

            <Flex direction="col" className="gap-2 mt-2 w-full md:!w-1/3">
              <CodeViewer
                language="javascript"
                copyable
                theme="dark"
                code={`import { Button } from "djuno-design";

function App() {
  return (
    <>
      <Button>Click!</Button>
    </>
  );
}`}
              />
            </Flex>
          </Flex>

          {/* Alert: DjunoDesignProvider */}
          <Alert
            uiType="info"
            message="Tip"
            description={
              <Typography.Text size="sm">
                For better control over themes and customization, wrap your
                application with{" "}
                <CustomLink to={ddpPageUrl}>
                  <Text size="sm" strong uiType="transparent">
                    DjunoDesignProvider
                  </Text>
                </CustomLink>
                . This allows you to set global styles, manage themes, and
                control package-specific configurations
              </Typography.Text>
            }
            className="mt-4"
            showIcon
          />
        </Flex>
      </Flex>
    </div>
  );
};

export default InstallationGuide;
